import { DOMHelpers } from 'helpers/dom';
import DiscussionNotificationsManager from 'managers/discussion/notifications';
import router from 'plugins/router';
import ShellLoggedInRoutes from './routes/loggedInRoutes';
import ShellPublicRoutes from './routes/publicRoutes';
import ShellRoutesComposition from './routes/routesComposition';
import ShellTermsRoutes from './routes/termsRoutes';
import Shell from './shell';

export default class DiscussionShell extends Shell {
    constructor() {
        super();

        //create shared notifications manager which belongs to shell and will stay alive during it life time
        this.storage.getInstance(DiscussionNotificationsManager, {});

        this.effects.register(isFullscreenLayoutRequested => {
            if (isFullscreenLayoutRequested)
                return DOMHelpers.assignClassToNode(document.body, 'flex-layout--fullscreen');
        }, [settings.ui.isFullscreenLayoutRequested]);
    }

    protected getRoutes() {
        return ShellRoutesComposition.create([
            new ShellTermsRoutes(this.storage),

            new ShellLoggedInRoutes([
                { route: 'topic/:discussionId/:topicId', moduleId: () => import('pages/discussions/topic/page') },
                { route: 'topic/:discussionId/:topicId/:defaultView', moduleId: () => import('pages/discussions/topic/page') },
                { route: 'activity/:discussionId/:activityId(/:view)', moduleId: () => import('pages/discussions/topic2/page') },
                { route: "account/twofactorauth", title: 'Two-Factor Authentication', moduleId: () => require('pages/account/twofactorauth/page') }
            ]),

            new ShellPublicRoutes([
                { route: '', title: 'Discussion', moduleId: () => import('pages/discussions/discussion/page') },

                { route: 'discussion', title: 'Discussion', moduleId: () => import('pages/discussions/discussion/page') },
                { route: 'agreetoterms', title: 'Agree To Terms', moduleId: () => import('pages/discussions/terms/page') },
                { route: 'resetPassword/:emailCode', title: 'Reset Password', moduleId: () => import('pages/discussions/password/reset/page') }, //todo: test  

                { route: 'preview', moduleId: () => import('pages/discussions/preview/page') },
                { route: 'waiting', moduleId: () => import('pages/discussions/waiting/page') },
                { route: 'message/discussion', moduleId: () => import('pages/discussions/message/page') },
                { route: 'publicscreener/:topicId', title: 'Screener', moduleId: () => import('pages/discussions/screener/screenerPage') },
                { route: 'screener/:topicId', title: 'Screener', moduleId: () => import('pages/discussions/screener/screenerPage') },
            ])
        ]);
    }

    protected override getInitialRoute() {
        return settings.page;
    }

    protected override afterActivate() {
        super.afterActivate();

        $('.topLogo')
            .css({ 'display': 'inline-block', 'cursor': 'pointer' })
            .click(() => location.reload()); // need to hard-refresh this in order to avoid routing issue with 2fa
            //.click(() => router.navigate('#'));
    }
}